import PointDeCollecteFormWrapper from "../../components/pointsDeCollecte/PointDeCollecteFormWrapper";

const PointDeCollecteCreate = () => {
  return <PointDeCollecteFormWrapper action="create" />;
};

export default PointDeCollecteCreate;
